const HEIC_MIME_TYPES = new Set(['image/heic', 'image/heif']);

const HEIC_UPLOAD_PLACEHOLDER = [
  '<svg xmlns="http://www.w3.org/2000/svg" width="640" height="640" viewBox="0 0 640 640">',
  '<rect width="640" height="640" rx="48" fill="#2f3033"/>',
  '<rect x="160" y="180" width="320" height="220" rx="28" fill="#3e4044"/>',
  '<circle cx="250" cy="250" r="32" fill="#6b7280"/>',
  '<path d="M190 360l70-72a18 18 0 0 1 26 1l47 48 34-34a18 18 0 0 1 25 0l58 57H190Z" fill="#7f8794"/>',
  '<text x="320" y="475" text-anchor="middle" fill="#d1d5db" font-family="Arial, sans-serif" font-size="54" font-weight="700">HEIC</text>',
  '<text x="320" y="530" text-anchor="middle" fill="#9ca3af" font-family="Arial, sans-serif" font-size="28">Фото с iPhone</text>',
  '</svg>',
].join('');

export const HEIC_UPLOAD_PLACEHOLDER_DATA_URL = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(HEIC_UPLOAD_PLACEHOLDER)}`;

export function isHeicLikeFile(file: Pick<File, 'type' | 'name'>): boolean {
  const mimeType = (file.type || '').toLowerCase();
  return HEIC_MIME_TYPES.has(mimeType) || /\.(heic|heif)$/i.test(file.name || '');
}

export function createImageUploadPreview(file: File): string {
  if (isHeicLikeFile(file)) {
    return HEIC_UPLOAD_PLACEHOLDER_DATA_URL;
  }

  return URL.createObjectURL(file);
}

export function createResolvedLocalImagePreview(originalFile: File, preparedFile: File, currentPreview?: string | null): string | null {
  if (!isHeicLikeFile(originalFile) || preparedFile === originalFile) {
    return null;
  }

  cleanupImageUploadPreview(currentPreview);
  return URL.createObjectURL(preparedFile);
}

export function resolveUploadedImagePreview(file: Pick<File, 'type' | 'name'>, currentPreview: string, uploadedUrl: string): string {
  if (isHeicLikeFile(file)) {
    cleanupImageUploadPreview(currentPreview);
    return uploadedUrl;
  }

  return currentPreview;
}

export function getUploadedImageRenderSrc(preview: string, cdnUrl?: string): string {
  return cdnUrl || preview;
}

export function cleanupImageUploadPreview(preview?: string | null): void {
  if (preview?.startsWith('blob:')) {
    URL.revokeObjectURL(preview);
  }
}
